import script from "./WantedPlateForm.vue?vue&type=script&setup=true&lang=js"
export * from "./WantedPlateForm.vue?vue&type=script&setup=true&lang=js"

import "./WantedPlateForm.vue?vue&type=style&index=0&id=375c63d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-375c63d4"]])

export default __exports__